import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fileServices } from "./file.services";
import { FILE_KEYS } from "./file.keys";

export const useCreateFile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fileServices.createFile,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: FILE_KEYS.lists(),
      });
    },
  });
};

export const useUpdateFile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fileServices.updateFile,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: FILE_KEYS.detail(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: FILE_KEYS.lists(),
      });
    },
  });
};

export const useDeleteFile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fileServices.deleteFile,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: FILE_KEYS.lists(),
      });
    },
  });
};

export const useCreateFiles = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fileServices.createFiles,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: FILE_KEYS.lists(),
      });
    },
  });
};
